import {List, styled} from '@mui/material';

const StyledList = styled(List)`
	width: 100%;
	position: relative;
	overflow: auto;
`;

export {StyledList};
